.search {
	display: flex;
	flex-direction: column;
	font: var(--lp-text-label-1-regular);
	gap: var(--lp-spacing-200);

	& input[data-rac] {
		&::-webkit-search-cancel-button,
		&::-webkit-search-decoration {
			appearance: none;
		}
	}

	&[data-empty] button[tabindex='-1'] {
		visibility: hidden;
	}
}
